<ion-content fullscreen class="full-bg">
  <app-fullscreen>
    <div class="container" header>
      <app-step-header
        [hideBack]="true"
        [hideProgress]="true">
      </app-step-header>
    </div>
    <div class="container feedback" body>
      <ion-card *ngFor="let message of messages">
        <ion-card-content>
          <p class="feedback-message">{{ message | translate }}</p>
        </ion-card-content>
      </ion-card>
    </div>
    <div footer>
      <app-footer
        [secondaryButton]="{
          hidden: true
        }"
        [primaryButton]="{
          text: 'btn.continue' | translate
        }"
        (primaryClick)="close()">
      </app-footer>
    </div>
  </app-fullscreen>
</ion-content>

